import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { AuthMapService } from '../../services/auth-map.service';
import { GoogleMapService } from '../../services/google-map.service';
import { OpenlayerMapService } from '../../services/openlayer-map.service';
import { CommonService } from '../../services/common.service';
import { AjaxService } from '../../services/ajax.service';
import { app, serverUrl, storageVariable, languageInitializer } from '../../../environments/environment';
import { WebsocketService } from '../../services/websocket.service';
import { websocket } from '../../interfaces/webSocket';
import { DatePipe } from '@angular/common'
import { ActivatedRoute, Route, Router } from '@angular/router';
import {
  trigger,
  style,
  state,
  animate,
  transition
} from '@angular/animations';
import { MenuController, Platform } from '@ionic/angular';
interface coordinates {
  lat: number;
  lng: number;
}

@Component({
  selector: 'app-vtslivetrack',
  templateUrl: './vtslivetrack.component.html',
  styleUrls: ['./vtslivetrack.component.scss'],
  providers: [DatePipe],
  animations: [
    trigger(
      'slide',
      [
        transition(':enter', [
          style({ transform: 'translateY(100%)' }),
          animate('0.3s ease-in')
        ]),
        transition(':leave', [
          animate('0.3s ease-out')
        ])
      ]
    )
  ]
})
export class VtslivetrackComponent implements OnInit, websocket {
  @Input() cardView;
  @Input('multiTrackObj') multiTrackObj = {}
  @Input('fromMultiTrack') fromMultiTrack = false
  map;
  map2;
  paramVin;
  ioData;
  appName;
  dashboardData;
  odometerReading;
  UpdatedTime;
  layerModal = false;
  traveVinData;
  transitionCount = 0;
  liveTrackPhoneNo = localStorage.getItem('PhoneNumber');
  liveTrackStatus;
  liveTrackSpeed;
  liveTrackTimeStamp;
  locationTimeStamp;
  liveTrackPlateNo;
  livetrackingAddress;
  liveTrackModel;
  position: coordinates = { "lat": 0, "lng": 0 };
  deltaLat;
  deltaLng;
  numDeltas = 700;
  hitPermission;
  displayText = 'Click here to locate Address';
  liveTrackOdometer;
  liveTrackCummulativeOdometer;
  liveTrackEngineValue;
  liveTrackFinalvalue;
  vin;
  gps;
  gsm;
  battery;
  powerSupplyVoltage;
  engine;
  ac;
  door;
  seatBelt;
  fabButton = true;
  icon = "assets/vtstrackhisIcon/";
  @Output() gridView = new EventEmitter();
  @Input() gridLiveChange;
  model;
  appSettings;
  showSwipeModal: boolean = true;
  toggleShow: boolean = false;
  // restrictedCommandImei = ["357544376950214", "864431049839964"];
  trackHistoryJson;
  currentState: string = "history";
  @ViewChild('mapElement', { static: false }) mapElement;
  @ViewChild('modal', { static: false }) modal;
  @Input() liveTrackChanging = undefined;
  locationIQ: any = [];
  count = 0;
  directory: string = languageInitializer.directory;
  pageSelector: any;
  constructor(
    public mapService: AuthMapService,
    public gMapService: GoogleMapService,
    public olMapService: OpenlayerMapService,
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public router: Router,
    public ajaxService: AjaxService,
    public websocketService: WebsocketService,
    public menuController: MenuController,
    public datePipe: DatePipe,
    // public platform: Platform

  ) {
    if (localStorage.map == "GoogleMap") {
      this.mapService = new GoogleMapService();
      this.fabButton = false;
    }
    else {
      this.mapService = new OpenlayerMapService();
    }
  }

  wsResponse(res) {
    // console.log("res vts-live",res);
    console.log(res, res.alerts, "vtslivetrack");
    if (Array.isArray(res.alerts) && res.alerts.length !== 0 && app.entryPoint == "ATM") {
      if (res.alerts[0].vid.alerttype == "POWERCUT" || res.alerts[0].vid.alerttype == "MOVEMENT") {
        this.commonService.playAudio();
      }
    } else {
      if (Array.isArray(res.alerts) && res.alerts.length !== 0)
        if (res.alerts[0].vid.alerttype == "SOS") {
          this.commonService.playAudio();
        }
    }

    var data = res.liveDatas
    if (data) {
      if (data[this.vin] != undefined) {
        this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[res["liveDatas"][this.vin].status], this.commonService.vehicleModelmap[res["liveDatas"][this.vin].icon]);
        this.currentState = "live";
        res["liveDatas"][this.vin]["odometer"] = parseInt(res["liveDatas"][this.vin]["odometer"]) / 1000;
        this.traveVinData = res["liveDatas"][this.vin];
        var constData = res;
        this.successLiveVariableData(constData);
        // this.updateCellData();
      }
    }
  }
  wsOnError() {
  }



  createMap() {
    setTimeout(() => {
      const myLatlng = {
        lat: this.traveVinData.latitude,
        lng: this.traveVinData.longitude
      };
      if (this.gridLiveChange == undefined || !this.map) {

        this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: this.traveVinData.latitude, lng: this.traveVinData.longitude }, false, false);
      }
      this.mapService.setCenter(this.map, { lat: 17.786351, lng: 78.090820 });
      this.mapService.clearLayers(this.map, [1, 2])
      this.vin = this.traveVinData.vin;
      this.locationIQ = [];//unused 
      this.count = 0
      this.liveTrackPlateNo = this.traveVinData.plateNo;
      this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[this.traveVinData.status], this.commonService.vehicleModelmap[this.traveVinData.icon]);
      this.updateCellData();
      this.mapService.addMarker(this.map, myLatlng, 'livetrack', this.liveTrackModel);
      this.mapService.setCenter(this.map, myLatlng);

      if (localStorage.map != "GoogleMap") {
        setTimeout(() => {
          this.mapService.fitBounds(this.map, 1);
        }, 500);
      }
      this.getLiveVariableData();
    }, 500);

  }

  switchMap() {
    this.layerModal = !this.layerModal
    this.map.getLayers().item(3).setVisible(this.layerModal);
    this.map.getLayers().item(0).setVisible(!this.layerModal);
  }
  updateCellData() { // dont delete unused function
    this.liveTrackSpeed = this.traveVinData.speed;
    this.liveTrackStatus = this.traveVinData.status;
    this.liveTrackTimeStamp = this.traveVinData.timeStamp;
    this.getAddress(this.traveVinData.latitude, this.traveVinData.longitude);
    this.liveTrackOdometer = (this.traveVinData.odometer / 1000).toFixed(3);
    this.liveTrackCummulativeOdometer = this.traveVinData.finalOdometer;
    this.liveTrackEngineValue = this.traveVinData.engineHours;
    this.liveTrackFinalvalue = this.traveVinData.finalEngineValue;
    this.gps = this.getIconColor('gps', this.traveVinData.gps);
    this.gsm = this.getIconColor('gsm', this.traveVinData.gsmSignalStrength);
    this.battery = this.getIconColor('battery', this.traveVinData.batteryvoltage);
    this.powerSupplyVoltage = this.getIconColor('powerSupplyVoltage', this.traveVinData.powerSupplyVoltage);
    this.engine = this.getIconColor('ignition', this.traveVinData.engineId);
    this.ac = this.getIconColor('acSensor', this.getIoDigitalinput("AirConditioner"));
    this.door = this.getIconColor('seatBelt', this.getIoDigitalinput("Door Sensor"));
    this.seatBelt = this.getIconColor('doorSensor', this.getIoDigitalinput("Seat Belt"));
  }

  getLiveVariableData() {
    const duration = this.appSettings.liveTrackingDelay;

    const credentials = {
      dashboardVin: this.vin,
      defaultInterval: duration,
      make: this.traveVinData.make,
      model: this.traveVinData.model,
      delay: duration,
      ImeiNo: this.traveVinData.imeiNo,
      entryPoint: app.entryPoint,
      Check: false,
      emailId: localStorage.userName,
      branchID: localStorage.corpId,
      companyID: localStorage.corpId,
      mode: 'liveTrackConnect'
    };
    // if (!this.restrictedCommandImei.includes(this.traveVinData.imeiNo))
    this.websocketService.reSendRequest(credentials);


  }
  check() { // unused function dont delete
    this.websocketService.isAlive('livetrack');
  }

  showTrackingPopup(myLatlng, liveVarData) { // unused function dont delete
    this.liveTrackStatus = this.commonService
      .liveTrackingStatus(liveVarData.model, liveVarData.status);
    this.liveTrackSpeed = liveVarData.speed + ' km/hr';
    this.liveTrackTimeStamp = liveVarData.timeStamp;
    this.locationTimeStamp = liveVarData.locationTimeStamp;
    this.liveTrackPlateNo = liveVarData.plateNo;
  }

  setLiveMarker(liveData, liveTatLng, check, check1, lineArray) {
    if (check) {
      if (check1) {
        this.mapService.moveMarker(this.map, 'livetrack', liveTatLng.lng, liveTatLng.lat, this.liveTrackModel, '', lineArray);
      } else {
        this.mapService.moveMarker(this.map, 'livetrack', liveTatLng.lng, liveTatLng.lat, this.liveTrackModel, '', lineArray);

      }
    } else {
      this.mapService.moveMarker(this.map, 'livetrack', liveTatLng.lng, liveTatLng.lat, this.liveTrackModel, '', lineArray);
      if (this.transitionCount === 100 || liveData.status === 'Running' || liveData.status === 'OverSpeed') {
      } else if (liveData.status === 'Stop' || liveData.status === 'Idle') {

      }
    }
  }

  // successLiveVariableData(data) {
  //   // this.count = 0;
  //   // this.locationIQ = []
  //   let currLatLng = {
  //     lat: data["liveDatas"][this.vin].latitude,
  //     lng: data["liveDatas"][this.vin].longitude
  //   };
  //   if (this.position.lat == 0 || this.position.lng == 0 || this.position.lat.toString() == "NaN" || this.position.lng.toString() == "NaN") {
  //     this.position.lat = currLatLng.lat;
  //     this.position.lng = currLatLng.lng;
  //   }

  //     var url = 'https://us1.locationiq.com/v1/matching/driving/' + this.position.lng + ',' + this.position.lat + ';' + this.traveVinData.longitude + ',' + this.traveVinData.latitude + '?key=c9cc1b3d7159e1&steps=false&geometries=geojson&radiuses=25;25&overview=full';
  //   this.ajaxService.ajaxGet(url).subscribe(async res => {
  //     if (res) {
  //       let newLength = res.matchings[0]["geometry"]["coordinates"]
  //       for (let i = 0; i < newLength.length; i++) {
  //         this.locationIQ.push(newLength[i])
  //       }

  //       for (this.count; this.count < this.locationIQ.length; this.count++) {
  //         let currLatLng = {
  //           lat: this.locationIQ[this.count][1],
  //           lng: this.locationIQ[this.count][0]
  //         };
  //         if (this.count != 0) {
  //           this.position.lng = this.locationIQ[this.count - 1][0];
  //           this.position.lat = this.locationIQ[this.count - 1][1];
  //           let currLatLng = {
  //             lat: this.locationIQ[this.count-1][1],
  //             lng: this.locationIQ[this.count-1][0]
  //           };
  //         }
  //         this.traveVinData.latitude = this.locationIQ[this.count][1];
  //         this.traveVinData.longitude = this.locationIQ[this.count][0];
  //         this.setLiveMarker(this.traveVinData, currLatLng, true, false, []);
  //         this.plotMarkerinMap(currLatLng);
  //       }
  //     }
  //   })
  // }

  toggleViews() {
    this.toggleShow = !this.toggleShow;

  }

  successLiveVariableData(data) {
    let currLatLng
    if (this.fromMultiTrack) {
      currLatLng = {
        lat: data.latitude,
        lng: data.longitude
      };
    } else {
      currLatLng = {
        lat: data["liveDatas"][this.vin].latitude,
        lng: data["liveDatas"][this.vin].longitude
      };
    }

    this.setLiveMarker(this.traveVinData, currLatLng, true, false, []);

    this.plotMarkerinMap(currLatLng);
  }

  plotMarkerinMap(currLatLng) {

    if (this.position.lat == 0 || this.position.lng == 0) {
      this.position.lat = currLatLng.lat;
      this.position.lng = currLatLng.lng;
    }
    const result = {
      lat: this.traveVinData.latitude,
      lng: this.traveVinData.longitude
    };
    if (this.position.lat !== result.lat && this.position.lng !== result.lng) {
      this.transition(result);

    } else {
      this.setLiveMarker(this.traveVinData, result, true, true, []);
      // this.transition(result);
    }
  }

  transition(result) {
    this.transitionCount = 0;
    this.deltaLat = (result.lat - this.position.lat)
      / this.numDeltas;
    this.deltaLng = (result.lng - this.position.lng)
      / this.numDeltas;
    this.moveMarker();
  }

  async moveMarker() {
    let lineArray;
    let prevLatLng = {
      "lat": this.position.lat,
      "lng": this.position.lng
    }
    this.position.lat += this.deltaLat;
    this.position.lng += this.deltaLng;
    const latlng = {
      lat: this.position.lat,
      lng: this.position.lng
    };
    let latLng = {
      "lat": this.position.lat,
      "lng": this.position.lng
    };
    lineArray = [prevLatLng, latLng];
    this.setLiveMarker(this.traveVinData, latlng, false, false, lineArray);
    if (this.transitionCount <= this.numDeltas) {
      this.transitionCount++;
      await this.delay(10);
      this.moveMarker();
    }
  }

  getAddress(lat, lng) {
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + this.traveVinData.latitude + "/" + this.traveVinData.longitude + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        this.livetrackingAddress = res;
      });
  }

  toggleView() {
    this.showSwipeModal = !this.showSwipeModal;
  }
  getIoDigitalinput(type) {
    if (this.ioData)
      for (let x in this.ioData[this.paramVin]) {
        if (type == this.ioData[this.paramVin][x]["ioname"]) {
          let value: string;
          switch (this.ioData[this.paramVin][x]["IO"]) {
            case 1:
              value = this.traveVinData.digitalInput1;
              break;
            case 2:
              value = this.traveVinData.digitalInput2;
              break;
            case 3:
              value = this.traveVinData.digitalInput3;
              break;
            case 4:
              value = this.traveVinData.digitalInput4;
              break;
            default:
              value = null;
              break;
          }

        }
      }
    return null;
  }
  getIconColor(icon, value) {
    let path;
    switch (value) {
      case 'ON':
        path = this.icon + icon + "On.svg";
        break;
      case 'OFF':
        path = this.icon + icon + "Off.svg";
        break;
      case true:
        path = this.icon + icon + "On.svg";
        break;
      case false:
        path = this.icon + icon + "Off.svg";
        break;
      case "true":
        path = this.icon + icon + "On.svg";
        break;
      case "false":
        path = this.icon + icon + "Off.svg";
        break;
      case '1':
        path = this.icon + icon + "Off.svg";
        break;
      case null:
        path = this.icon + icon + ".svg";
        break;
      default:
        path = this.icon + icon + "On.svg";
    }
    return path;
  }
  async delay(milliseconds: number) {
    return new Promise<void>(resolve => {
      setTimeout(resolve, milliseconds);
    });
  }

  ngOnDestroy() {
    if (this.websocketService.isAlive('livetrack')) {
      const duration = this.appSettings.liveTrackingDisconnect ? this.appSettings.liveTrackingDisconnect : this.appSettings.liveTrackingDelay;
      // this.websocketService.disConnectSocket('livetrack');
      const credentials = {
        dashboardVin: this.vin,
        defaultInterval: duration,
        make: storageVariable.upDatedJsonData.liveDatas[this.vin].make,
        model: storageVariable.upDatedJsonData.liveDatas[this.vin].model,
        delay: duration,
        ImeiNo: storageVariable.upDatedJsonData.liveDatas[this.vin].imeiNo,
        entryPoint: app.entryPoint,
        Check: false,
        emailId: localStorage.userName,
        branchID: localStorage.corpId,
        companyID: localStorage.corpId,
        // mode: "mobile"
        mode: 'liveTrackDisConnect'
      };

      // this.websocketService.setProductService(this);
      // this.websocketService.connectSocket(credentials, 'livetrack');
      // if (!this.restrictedCommandImei.includes(this.traveVinData.imeiNo))
      this.websocketService.reSendRequest(credentials);
    }

    this.mapService.clearLayers(this.map, [1, 2])
  }

  ionViewWillEnter() {
    setTimeout(() => {
      this.map.setTarget(this.mapElement.nativeElement);
    }, 2000);
  }

  getLiveTrackIcon = (color, path) => {
    if (path == undefined || path == null) {
      path = this.commonService.vehicleModelmap["CAR"]
    }
    if (this.traveVinData.icon == "REFRIGERATOR" || this.traveVinData.icon == "STREET SWEEPER") {
      var viewbox = "-220 -1000 2471.4 2448.1";
    }
    else if (this.traveVinData.icon == "FLATBED TRUCK") {
      var viewbox = "0 0 94 93";
      path='M48.233 61.4595C54.8011 61.4595 60.1255 66.7842 60.1255 73.3519C60.1255 79.9204 54.8011 85.2451 48.233 85.2451C41.6649 85.2451 36.3402 79.9204 36.3402 73.3519C36.3402 66.7842 41.6649 61.4595 48.233 61.4595ZM35.2094 72.7707C35.2094 74.6908 35.2463 75.2088 35.7514 77.0427C36.1986 78.665 37.4393 80.8723 38.6171 82.0426C38.7199 82.1442 38.7473 82.1766 38.8448 82.2895C38.9194 82.3757 38.8667 82.3219 38.9393 82.3987L39.0428 82.4984C39.0534 82.5078 39.0688 82.5206 39.0793 82.5297C39.8875 83.2373 39.6767 83.1402 40.6923 83.9002C43.3053 85.8549 44.9763 88.0347 46.5971 90.7434C46.9615 91.3521 47.281 92.0959 48.2285 92.0959C48.8319 92.0959 49.1966 91.7737 49.45 91.4187C49.7146 91.0479 49.9555 90.6045 50.1983 90.201L50.9372 88.9731C51.064 88.7616 51.154 88.6061 51.3079 88.395L52.1507 87.2714C52.7635 86.5204 53.819 85.4006 54.573 84.8111C54.7777 84.6511 54.879 84.5461 55.0958 84.3846C55.3092 84.2258 55.4707 84.1038 55.677 83.9491C57.5594 82.5368 59.1694 80.8271 60.1142 78.6214C61.9706 74.2862 61.5822 69.3886 58.8167 65.6403C58.7034 65.4867 58.619 65.3768 58.4971 65.2142C56.367 62.3723 52.4575 60.2263 48.0248 60.2263C43.253 60.2263 39.1746 63.0212 37.0267 66.5866C36.4109 67.6082 35.9035 68.8293 35.6159 69.9905C35.4074 70.8337 35.2094 71.722 35.2094 72.7707Z M40.5861 71.3858C40.6428 71.3819 40.6996 71.38 40.7565 71.3801L41.9202 71.3813C42.1182 71.3812 42.3207 71.377 42.5181 71.3847C42.7656 71.3943 42.7151 71.7463 42.7146 71.9196L42.7137 72.4732C42.7188 73.0212 42.7199 73.5692 42.717 74.1173C42.7152 74.2441 42.7334 74.3825 42.5686 74.3902C42.4388 74.3963 42.3076 74.392 42.1776 74.3913L41.3575 74.3877C41.2327 74.3872 41.0096 74.3752 40.9045 74.4217C40.7522 74.489 40.7952 74.9676 40.7959 75.114C40.6873 75.1158 40.5787 75.1167 40.4701 75.1169C40.45 74.8566 40.3806 74.6369 40.2048 74.4379C39.871 74.1124 39.4446 73.9798 39.0126 74.2147C38.9168 74.2603 38.8156 74.3582 38.7093 74.3754C38.4395 74.4191 38.1481 74.3687 37.8784 74.3907C37.8791 74.1636 37.8485 73.3645 37.9582 73.1971C37.9962 73.1392 38.0571 73.0843 38.1224 73.0593C38.3035 72.99 38.8067 72.9425 39.0218 72.9169C39.2053 72.8951 39.3869 72.8594 39.5699 72.833C39.7297 72.81 39.8922 72.797 40.0504 72.7649C40.1526 72.6273 40.4346 71.9215 40.4995 71.7428C40.3862 71.7394 40.154 71.7583 40.2915 71.5743C40.3702 71.469 40.4571 71.4035 40.5861 71.3858ZM41.0587 72.7673C41.1525 72.7673 41.7222 72.7765 41.766 72.7434C41.8319 72.6936 41.8288 71.8718 41.7944 71.8175C41.7049 71.7569 41.2736 71.7711 41.1452 71.7735C41.0571 71.7754 40.8292 71.7678 40.7876 71.8283C40.6912 71.9681 40.4406 72.5692 40.4077 72.7142C40.4735 72.7896 40.941 72.7671 41.0587 72.7673ZM42.357 72.7517C42.4008 72.7405 42.4005 72.748 42.4261 72.7184C42.4509 72.5659 42.4332 71.9587 42.4157 71.8C42.2996 71.7716 42.223 71.7765 42.1059 71.7814C42.0678 71.806 42.0496 71.8108 42.0398 71.863C42.0124 72.0099 42.0078 72.5953 42.047 72.7158C42.1019 72.7889 42.2771 72.7643 42.357 72.7517ZM41.7867 73.1594C41.8 73.1208 41.8032 73.1128 41.8014 73.0725C41.7499 73.0029 41.4922 73.0315 41.4017 73.0358C41.3946 73.0709 41.3915 73.0802 41.4006 73.1142C41.4571 73.1972 41.6915 73.1693 41.7867 73.1594Z M44.271 73.6046C44.3824 73.5988 44.5337 73.605 44.6476 73.6058L45.3089 73.6074L58.3359 73.6081C58.4397 73.6082 58.6743 73.5854 58.7581 73.6359C58.8162 73.6708 58.8221 73.8642 58.7748 73.9151C58.7391 73.9536 58.6353 73.9469 58.5828 73.9478C58.1448 73.9575 57.6933 73.952 57.2546 73.9519L45.1377 73.9481C44.8635 73.946 44.2754 73.9736 44.0382 73.9152C44.0306 73.6582 44.0007 73.6184 44.271 73.6046Z M43.3427 70.8135L43.3729 70.8147C43.4088 70.8661 43.3877 70.9943 43.3826 71.0635C43.3083 71.1136 43.2886 71.1332 43.2369 71.2067C43.2102 71.4034 43.2205 71.6613 43.2241 71.8631L43.3532 71.8833C43.3768 72.1293 43.3661 72.4795 43.3658 72.7338C43.3694 73.1587 43.3672 73.5836 43.3592 74.0083L43.2253 74.0296C43.2241 74.1201 43.224 74.2106 43.225 74.3011C43.5883 74.3171 44.0228 74.3009 44.399 74.3074C44.0905 74.5845 44.0462 74.7182 43.9802 75.1105C43.8386 75.1234 43.6376 75.12 43.4919 75.1203L42.7268 75.1198C42.6895 75.4714 42.4779 75.3671 42.1774 75.371C41.9953 75.3727 41.0781 75.3866 40.9677 75.344C40.941 75.322 40.9324 75.2987 40.9273 75.2648C40.9098 75.1482 40.8914 74.6267 40.9472 74.5542C41.0129 74.4689 42.4726 74.5361 42.7091 74.5015C42.7682 74.4433 42.8141 74.3858 42.8554 74.314L42.9576 74.293C42.9595 74.2044 42.9597 74.1158 42.9582 74.0272L42.841 74.0024C42.8366 73.7635 42.8234 71.993 42.8547 71.9081C42.8789 71.8779 42.9203 71.8681 42.9576 71.8548C42.9589 71.7465 42.9608 71.6247 42.9593 71.5166C42.954 71.1245 42.9876 70.986 43.3427 70.8135Z M48.432 74.087C48.8746 74.0759 49.3295 74.0799 49.773 74.0798L58.3396 74.0812C58.3404 74.2272 58.3452 74.3811 58.3245 74.5251C58.233 74.5352 58.1412 74.543 58.0492 74.5484C58.1158 74.8072 58.1505 74.8075 58.1586 75.1112C58.0868 75.1157 58.0127 75.1174 57.9406 75.1201C57.9288 74.9877 57.8994 74.8529 57.8458 74.7309C57.7417 74.4959 57.5489 74.3116 57.3096 74.2183C56.9724 74.1011 56.6698 74.1373 56.3804 74.3576C56.1293 74.5489 56.0399 74.8076 56.0011 75.1088C55.9691 75.1123 55.934 75.118 55.9018 75.1226C55.8667 74.9148 55.8307 74.7364 55.7043 74.5603C55.3984 74.1346 54.8023 74.014 54.3736 74.3303C54.101 74.5313 53.9989 74.799 53.9454 75.1173C53.8622 75.1194 53.8036 75.1142 53.7213 75.1069C53.7216 74.8882 53.781 74.7476 53.8428 74.544C53.4711 74.5248 52.965 74.5391 52.5859 74.5386L50.1377 74.5385L49.3991 74.5414C49.289 74.5418 48.9278 74.5638 48.8523 74.4964C48.7955 74.4455 48.4399 74.1349 48.432 74.087Z M54.8301 74.2956C55.2817 74.2425 55.6906 74.5666 55.742 75.0186C55.7935 75.4707 55.4679 75.8785 55.0158 75.9283C54.5661 75.9778 54.161 75.6542 54.1098 75.2045C54.0586 74.7548 54.3807 74.3484 54.8301 74.2956ZM55.0165 75.4974C55.2263 75.4466 55.3565 75.2366 55.3087 75.0259C55.2609 74.8153 55.0527 74.6821 54.8415 74.727C54.7022 74.7565 54.5896 74.8589 54.5469 74.9948C54.5041 75.1306 54.5378 75.279 54.635 75.3831C54.7323 75.4872 54.878 75.5309 55.0165 75.4974Z M46.832 74.3068C47.278 74.2221 47.7079 74.5161 47.7909 74.9626C47.8739 75.4091 47.5785 75.8381 47.1318 75.9195C46.6875 76.0005 46.2613 75.7068 46.1788 75.2626C46.0962 74.8184 46.3882 74.391 46.832 74.3068ZM47.0717 75.4983C47.2835 75.4514 47.4176 75.2422 47.3719 75.0301C47.3262 74.818 47.1178 74.6827 46.9055 74.7273C46.6917 74.7722 46.5551 74.9827 46.6012 75.1964C46.6473 75.4101 46.8584 75.5455 47.0717 75.4983Z M56.8786 74.2948C57.3302 74.245 57.7364 74.5722 57.7838 75.0243C57.8313 75.4764 57.5021 75.8809 57.0499 75.9261C56.6011 75.9709 56.2003 75.6446 56.1532 75.1958C56.1059 74.7469 56.4301 74.3443 56.8786 74.2948ZM57.0495 75.5013C57.2631 75.4557 57.3995 75.2457 57.3543 75.0319C57.3092 74.8182 57.0996 74.6813 56.8858 74.726C56.6714 74.7708 56.5341 74.9813 56.5793 75.1957C56.6246 75.4101 56.8353 75.547 57.0495 75.5013Z M44.9032 74.2931C45.3553 74.2702 45.7403 74.6184 45.7628 75.0707C45.7853 75.523 45.4369 75.9078 44.9848 75.93C44.5332 75.9521 44.149 75.604 44.1265 75.1523C44.104 74.7005 44.4516 74.3159 44.9032 74.2931ZM45.0277 75.4996C45.2406 75.4532 45.3758 75.2433 45.3301 75.0302C45.2843 74.8171 45.0748 74.6812 44.8617 74.7264C44.6477 74.7718 44.5113 74.9823 44.5572 75.1962C44.6031 75.4102 44.814 75.5461 45.0277 75.4996Z M39.3851 74.2963C39.8334 74.254 40.2315 74.5822 40.2759 75.0304C40.3203 75.4787 39.9943 75.8785 39.5464 75.9251C39.0954 75.9721 38.6923 75.6432 38.6476 75.1918C38.6029 74.7404 38.9337 74.3388 39.3851 74.2963ZM39.5456 75.4972C39.7577 75.4501 39.8917 75.2402 39.8452 75.0279C39.7986 74.8157 39.5891 74.6811 39.3768 74.7272C39.1638 74.7734 39.0287 74.9839 39.0754 75.1968C39.1221 75.4098 39.3328 75.5444 39.5456 75.4972Z M37.881 74.5148C38.0506 74.4989 38.448 74.5148 38.6339 74.5179C38.571 74.6357 38.5344 74.7123 38.4944 74.838C38.4671 74.9237 38.4618 75.1913 38.4119 75.2347C38.1808 75.246 37.8814 75.2868 37.6841 75.1775L37.6806 75.1469C37.6679 75.0281 37.6311 74.6745 37.7003 74.5668C37.7305 74.5197 37.8271 74.5182 37.881 74.5148Z M45.3059 74.0863C45.7319 74.0691 46.1785 74.0818 46.6058 74.0839C46.6517 74.0841 46.6893 74.1223 46.6828 74.1697C46.6443 74.2133 46.5504 74.2034 46.4952 74.2136C46.4655 74.2154 46.4911 74.2848 46.4668 74.3043C46.3286 74.4153 46.237 74.5005 46.1474 74.6546C46.0612 74.7613 46.0537 75.0174 46 75.1006C45.9762 75.1112 45.9172 75.1167 45.9079 75.09C45.8695 74.9795 45.8754 74.8607 45.8322 74.7496C45.7584 74.5595 45.6177 74.4291 45.4643 74.3038C45.4498 74.2919 45.4638 74.2484 45.4669 74.2272C45.4037 74.1752 45.3231 74.2292 45.2809 74.1445C45.2855 74.1149 45.2851 74.1074 45.3059 74.0863Z M47.8015 74.3011C47.8752 74.3003 48.1473 74.2812 48.1652 74.3689C48.1947 74.5144 48.2154 74.9467 48.1557 75.074C48.112 75.1179 48.0145 75.1204 47.9518 75.127C47.8959 74.7106 47.8282 74.5872 47.5185 74.304C47.6104 74.3059 47.7091 74.3027 47.8015 74.3011Z'
    } else if (this.traveVinData.icon == "FIRE & RESCUE TRUCK") {
      var viewbox = "0 0 94 93";
      path="M48.233 61.4595C54.8011 61.4595 60.1255 66.7842 60.1255 73.3519C60.1255 79.9204 54.8011 85.2451 48.233 85.2451C41.6649 85.2451 36.3402 79.9204 36.3402 73.3519C36.3402 66.7842 41.6649 61.4595 48.233 61.4595ZM35.2094 72.7707C35.2094 74.6908 35.2463 75.2088 35.7514 77.0427C36.1986 78.665 37.4393 80.8723 38.6171 82.0426C38.7199 82.1442 38.7473 82.1766 38.8448 82.2895C38.9194 82.3757 38.8667 82.3219 38.9393 82.3987L39.0428 82.4984C39.0534 82.5078 39.0688 82.5206 39.0793 82.5297C39.8875 83.2373 39.6767 83.1402 40.6923 83.9002C43.3053 85.8549 44.9763 88.0347 46.5971 90.7434C46.9615 91.3521 47.281 92.0959 48.2285 92.0959C48.8319 92.0959 49.1966 91.7737 49.45 91.4187C49.7146 91.0479 49.9555 90.6045 50.1983 90.201L50.9372 88.9731C51.064 88.7616 51.154 88.6061 51.3079 88.395L52.1507 87.2714C52.7635 86.5204 53.819 85.4006 54.573 84.8111C54.7777 84.6511 54.879 84.5461 55.0958 84.3846C55.3092 84.2258 55.4707 84.1038 55.677 83.9491C57.5594 82.5368 59.1694 80.8271 60.1142 78.6214C61.9706 74.2862 61.5822 69.3886 58.8167 65.6403C58.7034 65.4867 58.619 65.3768 58.4971 65.2142C56.367 62.3723 52.4575 60.2263 48.0248 60.2263C43.253 60.2263 39.1746 63.0212 37.0267 66.5866C36.4109 67.6082 35.9035 68.8293 35.6159 69.9905C35.4074 70.8337 35.2094 71.722 35.2094 72.7707Z M46.5921 70.9809L58.1662 70.9816L58.165 76.2044L58.2179 76.2029C58.4333 76.1969 58.5011 76.1824 58.6608 76.3334C58.6744 76.3851 58.6916 76.4467 58.6909 76.4947C58.6865 76.7557 58.7832 77.1665 58.3991 77.1786C58.1794 77.1855 57.9411 77.1821 57.7211 77.1825L56.2376 77.1828C56.2334 77.1767 56.2292 77.1707 56.225 77.1645C56.2378 77.02 56.2395 76.8614 56.2262 76.7203C56.1695 76.1685 55.8946 75.6622 55.4626 75.3142C55.0514 74.9714 54.5189 74.8098 53.9866 74.8664C52.8311 74.9863 52.0474 76.0459 52.1665 77.185C51.5442 77.1761 50.9038 77.1833 50.2805 77.1833L46.5944 77.1827C46.6058 76.8215 46.5967 76.4129 46.5969 76.0492L46.5981 72.0813C46.598 71.7246 46.6056 71.3347 46.5921 70.9809ZM47.6653 71.7806C47.625 71.8083 47.5766 71.8359 47.5751 71.8862C47.5716 72.0052 47.5724 72.1363 47.5723 72.2544L47.5723 73.1658L47.5672 75.4462C47.5669 75.6778 47.5501 76.386 47.5962 76.5824C47.6665 76.652 48.7167 76.6259 48.9061 76.6259H51.0411C51.0991 76.6255 51.1462 76.6278 51.2018 76.6074C51.2295 76.5726 51.2529 76.5459 51.2542 76.5004C51.2614 76.2286 51.2546 75.9514 51.256 75.6793L51.2564 72.4521C51.2567 72.2865 51.2573 72.1208 51.2551 71.9552C51.2543 71.887 51.2462 71.8477 51.1967 71.7987C51.071 71.7697 50.8222 71.7781 50.6837 71.7781L48.4555 71.7787C48.2002 71.7789 47.9182 71.7729 47.6653 71.7806ZM53.9096 73.1551C53.8164 73.0035 53.8227 72.9396 53.8091 72.7616C53.567 73.0283 53.383 73.3798 53.4007 73.7485C53.4132 74.0042 53.5287 74.244 53.7209 74.4131C53.9056 74.5777 54.087 74.6409 54.321 74.6981C54.1483 74.5797 54.0413 74.4746 53.9896 74.2576C53.9624 74.1429 53.9943 73.8249 54.1109 73.769C54.1537 73.789 54.2022 73.9083 54.2291 73.9567C54.2297 73.7183 54.2987 73.7267 54.3895 73.5251C54.4449 73.402 54.3412 73.3125 54.5094 73.2037L54.5229 73.2109L54.5239 73.2345C54.5329 73.4369 54.6073 73.4411 54.6836 73.6297L54.6869 73.6437C54.7005 73.705 54.7031 73.7247 54.7009 73.7868C54.6981 73.8684 54.6199 73.9628 54.6666 74.0265C54.7986 74.0451 54.8406 73.8829 54.8707 73.7884C55.1566 74.122 55.0199 74.4763 54.6766 74.6928C54.8193 74.6611 54.9519 74.6354 55.0799 74.5613C55.8021 74.1432 55.7177 73.3617 55.2621 72.7871C55.2674 72.9574 55.2818 73.1528 55.16 73.2888C55.1055 73.3498 55.0389 73.3985 54.9639 73.3458C54.886 73.2002 55.0027 73.0846 55.0141 72.9446C55.0596 72.3842 54.6827 71.95 54.213 71.7102C54.3382 71.9684 54.33 72.2357 54.2392 72.5033C54.1563 72.7476 54.0081 72.9257 53.9096 73.1551Z M47.7482 71.9754C48.8494 71.9754 49.9699 71.9867 51.0695 71.9736C51.0793 72.9508 51.0545 75.3125 51.0685 76.412C51.0626 76.4179 51.0568 76.4239 51.0509 76.43L51.0049 76.4287L47.7562 76.4335L47.7513 73.3964C47.7515 72.9457 47.7674 72.4167 47.7482 71.9754ZM50.659 74.9686C50.7933 74.8861 50.7401 74.7553 50.6065 74.7524C50.3362 74.7462 50.0644 74.7504 49.7939 74.7506L48.1562 74.7532C48.0929 74.8058 48.0684 74.8472 48.1056 74.9274C48.1316 74.9483 48.1514 74.9619 48.1861 74.9638C48.3926 74.9753 48.6152 74.9707 48.8222 74.9707L50.0516 74.9694C50.2419 74.9691 50.4751 74.9583 50.659 74.9686ZM49.0164 75.8823C48.9561 75.919 48.9151 75.9609 48.9408 76.0368C48.9835 76.0847 49.0521 76.1006 49.1137 76.1008C49.3525 76.1017 49.594 76.1001 49.8326 76.0993C49.9857 75.9989 49.8811 75.8879 49.7537 75.8842C49.5224 75.8773 49.2727 75.8776 49.0418 75.8814C49.0333 75.8815 49.0249 75.8819 49.0164 75.8823ZM50.6686 73.8173C50.7273 73.7715 50.7581 73.7294 50.717 73.6536C50.6589 73.6028 50.5361 73.6087 50.46 73.61C49.694 73.624 48.9139 73.59 48.1491 73.6103C48.1138 73.6442 48.0881 73.6742 48.0886 73.7274C48.0888 73.754 48.1007 73.7791 48.1213 73.7959C48.1744 73.839 48.5447 73.8199 48.6384 73.8193L49.3649 73.8185C49.7478 73.8186 50.2953 73.8363 50.6686 73.8173ZM48.134 74.1848C48.1058 74.2262 48.0802 74.2679 48.0915 74.32C48.0967 74.3441 48.1119 74.3671 48.1354 74.3775C48.1974 74.405 50.5021 74.4087 50.677 74.3892C50.7299 74.3382 50.7595 74.2816 50.71 74.2131C50.6401 74.1609 50.3207 74.1801 50.2171 74.1803L49.4375 74.1814L48.5976 74.1813C48.4599 74.1812 48.268 74.1758 48.134 74.1848ZM48.1668 72.467C48.1238 72.4936 48.0998 72.514 48.0904 72.5662C48.0628 72.7175 48.3728 72.6788 48.4635 72.6789L50.086 72.6795C50.2104 72.6794 50.6143 72.6916 50.7051 72.6588C50.7332 72.6073 50.7573 72.4854 50.6759 72.4818C49.8434 72.445 49.0015 72.4869 48.1668 72.467ZM50.678 75.5332C50.769 75.4444 50.7606 75.3335 50.6149 75.3311C50.0072 75.3214 49.3984 75.3284 48.7904 75.3271C48.5763 75.3266 48.3525 75.322 48.1394 75.3316C48.1036 75.3691 48.0869 75.3884 48.0893 75.4439C48.0924 75.5214 48.162 75.5372 48.2227 75.5374C48.7392 75.5395 49.2558 75.5386 49.7723 75.5385L50.3553 75.5383C50.4279 75.5383 50.6111 75.5415 50.678 75.5332ZM48.1357 73.0433C48.1083 73.0822 48.0824 73.1239 48.0907 73.1741C48.0944 73.1964 48.1137 73.2254 48.1348 73.2346C48.196 73.2612 50.5805 73.2695 50.683 73.2416C50.7767 73.1461 50.7484 73.0442 50.6095 73.0399C50.4627 73.0353 50.316 73.037 50.1691 73.037L48.5824 73.0375C48.4512 73.0376 48.261 73.0325 48.1357 73.0433Z M40 69.4079C40.0223 69.4069 40.0446 69.4061 40.0669 69.4054C40.4657 69.3933 40.9233 69.4041 41.3266 69.4041L45.2152 69.4042C45.4682 69.4038 45.7335 69.3984 45.9862 69.4096C46.0923 69.4202 46.1981 69.4808 46.2732 69.551C46.4441 69.7109 46.41 69.9372 46.4147 70.1485C46.4177 70.282 46.4156 70.4207 46.4157 70.5559L46.4126 72.0636L46.4144 77.1854L44.4298 77.1823C44.4777 76.6145 44.3674 76.1342 44.0175 75.6744C43.6585 75.2025 43.1843 74.9401 42.6007 74.8627C42.4806 74.8563 42.3684 74.8522 42.2481 74.8608C41.2319 74.9345 40.3964 75.8169 40.3623 76.8324C40.3581 76.9555 40.3629 77.0598 40.372 77.1821L38.7137 77.182C38.4608 77.1815 38.2034 77.1859 37.9506 77.1827C37.5289 77.1707 37.6617 76.8107 37.6309 76.5549C37.5553 75.9264 38.0176 76.0518 38.4925 76.0528L39.3543 76.0525C39.4548 76.053 39.6855 76.0857 39.7243 75.9791C39.7156 75.9348 39.7098 75.9319 39.6848 75.8953C39.622 75.8519 39.204 75.8718 39.0976 75.8718L37.9818 75.8699C37.9709 75.5847 37.9831 75.2751 37.9779 74.9868C37.9805 74.7832 37.9709 74.579 37.9834 74.3758C37.9944 74.1969 38.099 74.1379 38.261 74.1088C38.266 73.8419 38.2425 73.4099 38.2895 73.1641C38.3146 73.033 38.4882 72.6194 38.545 72.4763L39.0183 71.2751L39.4538 70.1577C39.5196 69.9879 39.5982 69.766 39.6795 69.604C39.7317 69.4999 39.887 69.4355 40 69.4079ZM42.7206 72.5005C42.7717 72.4614 42.789 72.4503 42.8302 72.4025C42.8474 72.2804 42.8418 72.1118 42.8419 71.9857L42.843 70.6077C42.8431 70.4849 42.8451 70.3613 42.8411 70.2387C42.8384 70.1557 42.7847 70.1143 42.7224 70.0719C42.4828 70.0529 42.1207 70.0628 41.8741 70.063L40.3539 70.0628C40.2695 70.071 40.1996 70.0842 40.1411 70.1503C40.1064 70.1896 39.0589 72.8328 38.9896 73.0416C38.9794 73.0723 38.9748 73.1018 38.9789 73.134C38.984 73.1736 39.0024 73.2066 39.0362 73.2288C39.0753 73.2545 39.1234 73.2641 39.1691 73.2696C39.3022 73.2856 40.0736 73.278 40.1802 73.2518C40.4012 73.1974 40.7158 72.8212 40.8895 72.6565C41.1292 72.4563 41.3576 72.5133 41.6472 72.5056C42.0017 72.496 42.3671 72.5201 42.7206 72.5005ZM45.6238 72.5037C45.6744 72.487 45.7394 72.4556 45.7609 72.4022C45.7943 72.3197 45.7917 70.4491 45.7788 70.2402C45.7773 70.2157 45.7735 70.1909 45.7625 70.1687C45.7417 70.1268 45.6987 70.0979 45.6608 70.073C45.4823 70.054 45.1552 70.0627 44.9629 70.0629L43.7054 70.063C43.5914 70.0689 43.4825 70.0856 43.4743 70.2254C43.4645 70.3937 43.4673 70.563 43.4673 70.7316L43.4676 71.592C43.4674 71.8421 43.4625 72.1315 43.4743 72.3816C43.4764 72.4258 43.5444 72.4751 43.5816 72.4998C43.7952 72.5162 44.1008 72.5073 44.3197 72.5069L45.6238 72.5037ZM39.2696 75.4804C39.3248 75.4419 39.3525 75.4159 39.3628 75.3475C39.3726 75.2828 39.3726 74.8537 39.3647 74.7802C39.3612 74.7478 39.3567 74.7111 39.3331 74.6864C39.237 74.5856 38.6126 74.6245 38.4592 74.6297C38.3033 74.746 38.3696 74.864 38.3616 75.0317C38.3573 75.1229 38.341 75.3924 38.3918 75.4331C38.4999 75.5197 39.1566 75.4905 39.2696 75.4804ZM45.1733 73.6199C45.3652 73.4891 45.2786 73.302 45.0895 73.3022C44.8174 73.3022 44.5338 73.2938 44.2627 73.3049C44.0462 73.4488 44.148 73.6172 44.3774 73.6212C44.6425 73.626 44.9082 73.6179 45.1733 73.6199Z M46.0952 66.7298C46.2066 66.7224 46.3901 66.7669 46.5054 66.7885L55.6824 68.5255L57.1962 68.8059C57.3815 68.8407 57.5781 68.8714 57.7588 68.9127C57.8794 68.9404 57.9547 69.1813 57.8168 69.2587C57.6749 69.3383 57.5142 69.2822 57.3701 69.2493C57.3319 69.4283 57.3003 69.6777 57.2728 69.8624C57.751 69.8452 57.6965 70.1964 57.6994 70.5429C57.8624 70.5767 57.8464 70.6494 57.8463 70.7895L57.2337 70.7886C56.8434 70.7861 56.4528 70.7921 56.0624 70.7857C56.0664 70.3961 56.2395 70.7314 56.2317 70.3572C55.4377 70.1939 54.5879 70.0554 53.7862 69.9066L46.8187 68.6122C46.5205 68.5565 46.2205 68.5017 45.9223 68.4458C45.6354 68.392 45.7028 68.0215 45.9572 68.0401C46.1134 68.0516 46.2942 68.0938 46.4505 68.1248C46.4641 67.9351 46.5641 67.4354 46.6001 67.2265C46.4554 67.2049 46.0514 67.181 45.9743 67.0334C45.9098 66.91 45.9781 66.7953 46.0952 66.7298ZM48.4092 68.4814C48.7415 68.5507 49.1571 68.6024 49.4722 68.6784C49.5012 68.418 49.5752 68.0699 49.621 67.8037C49.2835 67.7412 48.89 67.6788 48.5578 67.6068C48.5124 67.8796 48.4648 68.2148 48.4092 68.4814ZM51.4275 69.0558C51.7079 69.0786 52.1827 69.1929 52.4801 69.2396C52.5299 68.9586 52.5722 68.6425 52.6299 68.3679C52.4046 68.3297 52.1796 68.2891 51.9552 68.2461C51.8464 68.2259 51.6732 68.1991 51.5716 68.1734C51.5477 68.3983 51.4782 68.8278 51.4275 69.0558ZM49.9242 68.7699C50.1159 68.793 50.3174 68.8354 50.5083 68.8703C50.6544 68.897 50.831 68.9233 50.9742 68.958C51.0129 68.7417 51.0785 68.2826 51.1264 68.0919C50.8067 68.031 50.375 67.9652 50.0714 67.8911C50.0255 68.1845 49.9764 68.4775 49.9242 68.7699ZM46.9048 68.2058C47.2266 68.2582 47.6463 68.3284 47.9621 68.3997C47.9728 68.2661 48.0684 67.6631 48.1046 67.5173C47.7606 67.4524 47.3912 67.3931 47.0524 67.3221C47.014 67.5553 46.928 67.982 46.9048 68.2058ZM56.0663 69.0199C56.0491 69.2063 55.9673 69.6944 55.9228 69.8827C56.0506 69.9057 56.2297 69.9426 56.3548 69.9566C56.5104 69.8431 56.5719 69.8583 56.7668 69.8606C56.8108 69.8608 56.8241 69.8673 56.8587 69.8479C56.9091 69.6455 56.9284 69.395 56.9752 69.1825C56.694 69.1335 56.3394 69.0561 56.0663 69.0199ZM54.5814 68.7438C54.5457 68.9875 54.4855 69.3719 54.4322 69.6104C54.6681 69.6495 54.9032 69.6917 55.138 69.7368C55.1917 69.7467 55.4286 69.7921 55.4734 69.791C55.5266 69.5218 55.5668 69.1892 55.6271 68.9336C55.2779 68.8735 54.9294 68.8103 54.5814 68.7438ZM53.9862 69.5223C54.031 69.2516 54.0778 68.9211 54.1333 68.6556C53.7963 68.5944 53.4054 68.5101 53.0724 68.4644C53.0485 68.7429 52.9727 69.0473 52.9358 69.3275C53.2701 69.3929 53.6506 69.466 53.9862 69.5223Z M54.0502 75.2083C55.0004 75.1298 55.8336 75.8379 55.9096 76.7882C55.9856 77.7386 55.2754 78.57 54.3248 78.6435C53.3777 78.7168 52.55 78.0098 52.4744 77.0628C52.3987 76.1159 53.1035 75.2864 54.0502 75.2083ZM54.3122 77.8806C54.84 77.8139 55.2128 77.3304 55.1431 76.8029C55.0734 76.2754 54.5879 75.9052 54.0607 75.9778C53.5377 76.05 53.1711 76.5309 53.2403 77.0543C53.3094 77.5777 53.7883 77.947 54.3122 77.8806Z M54.1872 76.4379C54.4563 76.4347 54.6772 76.6497 54.6814 76.9187C54.6854 77.1877 54.4712 77.4094 54.2022 77.4144C53.9319 77.4194 53.709 77.2039 53.7048 76.9337C53.7007 76.6634 53.9169 76.4411 54.1872 76.4379Z M42.2669 75.2077C43.2178 75.1349 44.0468 75.8486 44.1164 76.7998C44.186 77.7508 43.4696 78.5775 42.5183 78.6439C41.5714 78.71 40.7494 77.9978 40.6801 77.0511C40.6109 76.1044 41.3204 75.28 42.2669 75.2077ZM42.5302 77.8792C43.0576 77.8048 43.4238 77.3154 43.3462 76.7883C43.2686 76.2614 42.7769 75.8982 42.2503 75.9789C41.7283 76.0592 41.369 76.5457 41.4459 77.0682C41.5228 77.5907 42.0072 77.953 42.5302 77.8792Z M42.2793 76.4503C42.4512 76.4089 42.6322 76.4632 42.7528 76.5927C42.8734 76.7221 42.9149 76.9065 42.8614 77.0751C42.8079 77.2437 42.6677 77.3704 42.4945 77.4065C42.2325 77.4613 41.9749 77.2957 41.9161 77.0345C41.8573 76.7732 42.019 76.5132 42.2793 76.4503Z M47.0229 70.2568C47.7253 70.2764 48.5141 70.2613 49.2193 70.2564L51.1476 70.2605C51.5281 70.2611 51.9096 70.2585 52.2901 70.2565C52.3271 70.2609 52.4315 70.2542 52.4551 70.2874C52.53 70.393 52.5032 70.6571 52.5048 70.7875L52.2823 70.788L46.8897 70.7918C46.8899 70.6657 46.8539 70.3963 46.923 70.2979C46.9456 70.2657 46.986 70.2621 47.0229 70.2568Z M42.0265 67.726C42.0433 67.7243 42.0601 67.7233 42.0769 67.723C42.2767 67.7204 42.4906 67.8117 42.6327 67.9514C42.8825 68.1969 42.8481 68.4726 42.8491 68.7931C42.6317 68.7898 42.4106 68.7913 42.1928 68.7907L41.3305 68.793C41.3272 68.535 41.3044 68.2801 41.4576 68.0589C41.6015 67.8511 41.787 67.7707 42.0265 67.726Z M58.3672 71.8209C58.4791 71.8089 58.5445 71.8111 58.6486 71.8474C58.7151 71.8705 58.8225 71.9832 58.8284 72.0378C58.8474 72.2155 58.8407 72.4441 58.8408 72.6239L58.84 73.9962C58.8389 74.2635 58.8479 74.5307 58.8394 74.7978C58.8339 74.9704 58.7353 75.0697 58.5719 75.109L58.3486 75.1186L58.3496 74.8262C58.4055 74.8243 58.4566 74.8328 58.5003 74.8048C58.5249 74.7681 58.5271 74.7751 58.5266 74.7093C58.5206 73.8575 58.5408 72.9998 58.5193 72.1488C58.5119 72.1411 58.5044 72.1334 58.4969 72.1257C58.4463 72.1051 58.4045 72.11 58.3494 72.11C58.3501 72.0491 58.3405 71.8508 58.3672 71.8209Z M41.1656 68.9788C41.3879 68.9703 42.9585 68.955 43.0462 68.9952C43.0898 69.0151 43.1273 69.0549 43.1433 69.1002C43.1582 69.1423 43.1484 69.1676 43.1304 69.205C43.0893 69.2312 43.0904 69.2215 43.0315 69.221L41.7641 69.2212C41.6619 69.2213 41.083 69.2385 41.0347 69.1958C41.0003 69.1151 41.0929 69.0139 41.1656 68.9788Z M42.048 66.5669C42.0726 66.5649 42.0974 66.566 42.1217 66.5699C42.2513 66.5899 42.2557 66.7709 42.2414 66.8714C42.2147 67.0601 42.3138 67.3159 42.1446 67.4295C42.1192 67.4304 42.0938 67.4296 42.0685 67.427C42.0358 67.4233 41.9817 67.3982 41.975 67.3704C41.9271 67.173 41.9513 66.88 41.9585 66.6735C41.9603 66.623 42.016 66.5904 42.048 66.5669Z M40.6943 67.1321C40.8191 67.153 40.936 67.2869 41.0317 67.3716C41.1542 67.48 41.4237 67.6879 41.1695 67.812C41.0876 67.8092 41.0158 67.7625 40.9621 67.7028C40.8385 67.5656 40.3611 67.2943 40.6943 67.1321Z M43.4219 67.1438C43.8481 67.107 43.4716 67.5211 43.3303 67.6065C43.2635 67.6469 43.1738 67.753 43.0893 67.8062C43.0803 67.807 43.0712 67.8075 43.0621 67.8078C42.8636 67.8144 42.8801 67.6303 42.9968 67.5192C43.1355 67.3873 43.2758 67.2672 43.4219 67.1438Z"
    }
    else {
      var viewbox = "-950 -1600 2471.4 2448.1";
    }
    let svg = '<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24.714mm" height="24.481mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  ' +
      '   viewBox="'
      + viewbox +
      '"    xmlns:xlink="http://www.w3.org/1999/xlink"> <path class="fil0" d="'
      + path
      + '" fill="'
      + color
      + '"/> </svg>';

    if (app.entryPoint == "WFT")
      svg = `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="20mm" height="20mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  viewBox="0 -700 600.4 1548.1"  xmlns:xlink="http://www.w3.org/1999/xlink">
      <path fill="${color}" d="M308.39 820.52c7.93,-5.39 22.74,-25.21 31.19,-34.54 4.5,-4.96 6.68,-7.44 10.81,-12.32 13.75,-16.21 26.97,-32.81 40.77,-49.55 27.52,-33.41 51.55,-66.36 78.26,-102.19 45.87,-61.48 105.82,-157.78 131.51,-228.19 19.86,-54.37 22.8,-94.92 9.4,-154.59 -28.91,-128.85 -148.82,-238.55 -301.79,-238.39 -57.68,0.07 -99.9,14.16 -143.75,35.48 -18.95,9.22 -40.4,24.78 -54.11,36.16 -47.86,39.76 -87.79,99.86 -103.04,166.42 -13.17,57.47 -10.42,101.62 9.13,154.27 33.45,90.11 110.12,204.33 169.31,279.35 6.69,8.48 13.02,16.66 19.69,25.42 31.33,41.1 68.67,83.6 102.62,122.67zm-91.96 -457.11l0 70.27 185.2 0 0 -70.27c0,-15.94 -6.44,-33.7 -14.55,-45.81l-8.8 -11.88c-21.18,-22.85 -23.92,-15.31 -39,-9.62 -3.69,1.39 -12.54,3.64 -17.03,3.64l0 65.32c0,20.67 -26.45,20.67 -26.45,0l0 -65.32c-4.4,0 -12.9,-2.15 -16.43,-3.42 -8.9,-3.18 -14.09,-8.4 -22.55,-4.98 -2.19,0.9 -3.94,2.56 -5.9,4.03 -6.3,4.7 -10.44,9.47 -15.22,15.37 -10.73,13.22 -19.27,34.8 -19.27,52.67zm171.97 -118.23l0 6.62c0,24.96 24.64,49.59 49.61,49.59l6.61 0c24.97,0 49.61,-24.63 49.61,-49.59l0 -6.62c0,-24.97 -24.64,-49.61 -49.61,-49.61l-6.61 0c-24.97,0 -49.61,24.64 -49.61,49.61zm-264.57 0l0 6.62c0,24.96 24.64,49.59 49.61,49.59l6.61 0c24.97,0 49.61,-24.63 49.61,-49.59l0 -6.62c0,-24.97 -24.64,-49.61 -49.61,-49.61l-6.61 0c-24.97,0 -49.61,24.64 -49.61,49.61zm-13.23 119.05l0 57.88c0,5.16 6.41,11.57 11.57,11.57l67.8 0c0,-26.79 -2.14,-72.3 4.13,-95.91 3.41,-12.82 10.28,-26.05 10.76,-28.11 -5.87,0 -8.35,1.66 -13.55,2.99 -31.15,8 -36.23,-10.65 -51.95,0.14 -15.05,10.32 -28.76,29.45 -28.76,51.44zm330.72 -49.61c-3.75,0 -11.13,-1.08 -14.57,-1.97 -5.2,-1.33 -7.68,-2.99 -13.55,-2.99 0.42,1.77 7.36,15.7 10.58,27.46 6.51,23.71 4.31,69.65 4.31,96.56l67.8 0c5.16,0 11.57,-6.41 11.57,-11.57l0 -57.88c0,-18.22 -10.28,-34.7 -19.62,-44.04 -20.65,-20.63 -23.06,-5.57 -46.52,-5.57zm-198.43 -109.13c0,21.76 5.65,36.66 19.21,50.24 25.88,25.87 68.24,25.63 93.86,0.01 25.62,-25.62 25.87,-67.99 -0.01,-93.86 -25.77,-25.78 -68.08,-25.78 -93.85,0 -9.14,9.14 -19.21,25.74 -19.21,43.61zm31.19 -146.63c-131.97,17.76 -244.14,138.21 -224,293.5 17.03,131.47 139.15,243.81 292.89,224.18 131.7,-16.82 245.65,-139.54 224.9,-293.98 -17.7,-131.69 -139.26,-244.5 -293.79,-223.7z"/>
      </svg>`;
    // svg = `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24.714mm" height="15.481mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  ' +
    // '   viewBox="0 0 2471.4 1548.1"  ' +
    // '    xmlns:xlink="http://www.w3.org/1999/xlink">
    //   <path `+ `fill="`
    //   + color
    //   + `" d="M185.45 141.92c1.88,-0.62 3.59,-0.87 4.42,1.01l0.12 -39.84c-9.89,-1.85 -20.2,7.31 -23.44,11.92 -6.64,9.41 -5.4,17.94 -5.4,30.53 0,24.09 0.02,48.19 0,72.28 0,5.04 -0.84,12.18 1.45,16.27 1.99,3.56 6.15,6.96 12.29,6.12 11.97,-1.65 10.02,-15.29 10,-26.37 -0.02,-11.15 -1.26,-65.87 0.56,-71.92zm56.48 282.37l-15.27 15.27 -15.27 -15.27c-40.35,-7.21 -70.98,-42.48 -70.98,-84.9 0,-2.33 0.09,-4.64 0.28,-6.93 3.53,44.39 40.76,81.52 86.06,81.52 45.3,0 82.36,-37.13 85.89,-81.51 0.18,2.28 0.28,4.59 0.28,6.92 0,42.42 -30.63,77.69 -70.98,84.9zm50.24 -223.81c-0.25,-20.92 -0.03,-41.98 -0.03,-62.93 0.02,-14.11 -3.24,-25.43 -16.11,-31.72 -3.33,-1.63 -8.53,-3.53 -12.69,-2.76l0.02 39.87c1.24,-1.95 2.66,-1.64 4.54,-1.09 2.58,8.28 -0.87,83.37 1.05,89.99 3.07,10.58 17.15,11.32 21.99,1.87 2.15,-4.21 1.13,-12.2 1.24,-17.43l-0.04 -1.76 0.06 -11.57 -0.02 -2.48zm-98.54 15.06l0 12.52 -1.7 0.65c-1.3,0.39 -0.26,-0.24 -1.84,0.48 -0.59,14.19 -0.07,29.52 -0.07,43.83l0 88.79c0,10.15 -2.76,27.83 13.46,31.12 7.53,1.54 12.48,-1.53 16.08,-5.21 4.93,-5.06 4.53,-9.8 4.52,-17.95l0 -121.8c0,-3.24 -0.92,-8.36 2.57,-8.35 3.4,0 2.59,4.62 2.56,7.78l0.03 121.81c0,7.73 -0.58,13.22 4.24,18.23 10.19,10.62 24.02,5.48 28.33,-4.15 2.37,-5.3 1.49,-14.63 1.49,-20.92 0,-14.8 0,-29.59 0,-44.4 0,-29.08 1,-59.94 -0.07,-88.8l-3.55 -1.14 -0.04 -13.1 0.07 -112.15 -7.96 0 0.01 80.74 -19.63 -0.96c-0.38,-8.12 -0.06,-16.85 -0.06,-24.89 0,-14.89 9.29,-41.68 15.96,-54.64l-42.87 -0.26c4.55,16.94 13.29,38.72 13.29,55.24 0,8.23 0.32,17.17 -0.06,25.31l-16.68 0.2 -0.17 -80.69 -7.9 -0.08 -0.03 112.76zm25.49 -179.99c-3.48,2.8 -3.86,-3.15 -4.28,-5.7 -0.51,-3.02 -1.07,-7.49 -1.87,-9.97 -9.11,4.71 -15.26,13.52 -16.39,27.17 -2.33,1.19 -5.11,0.84 -5.43,4.57 -0.33,3.76 1.87,5.04 5.34,5.04l60.34 0.01c3.31,-0.01 5.34,-1.08 5.35,-4.5 0.02,-4.41 -2.91,-3.86 -5.48,-5.13 -1.15,-13.83 -7.34,-22.37 -16.39,-27.18 -1.99,6.28 -1.51,19.79 -6.12,15.69 -2.54,-2.51 1.99,-14.87 1.51,-19.24 -1.7,-3.24 -8.35,-2.48 -11.9,-2.48 -13.8,0 0,17.11 -4.69,21.72zm34.49 27.26l-53.91 -0.18c-2.22,15.81 12.37,28.94 26.96,28.94 14.56,0 29.18,-13.22 26.95,-28.76z"/>
    // </svg>

    // `
    const src = 'data:image/svg+xml;charset=utf-8,'
      + encodeURIComponent(svg);
    return src;
  }
  trackHistory() {
    let date = new Date(this.traveVinData.timeStamp);
    let now = (date).toJSON();
    let from = (new Date(date.getTime() - 1000 * 60)).toJSON();
    this.commonService.presentLoader();
    if (!this.vin)
      this.vin = this.traveVinData.vin
    const url = serverUrl.web + '/device/trackhistory?vehicleNo=' + this.vin + '&fromDate=' + this.datePipe.transform(now, 'yyyy-MM-dd') +
      '&fromtime=' + this.datePipe.transform(from, 'HH:mm:ss') + '&totime=' + this.datePipe.transform(now, 'HH:mm:ss') + '&entryPoint=' + app.entryPoint;

    // let body = {
    //   "vin": this.vin,
    //   "fromDate": this.datePipe.transform(now, 'yyyy-MM-dd') + " " + this.datePipe.transform(from, 'hh:mm:ss a'),
    //   "toDate": this.datePipe.transform(now, 'yyyy-MM-dd') + " " + this.datePipe.transform(now, 'hh:mm:ss a'),
    // }
    this.ajaxService.ajaxGet(url)
      .subscribe(res => {
        if (this.commonService.isLoading)
          this.commonService.dismissLoader();
        let trackHistory = [];
        let trackHistoryArray = res.routeGeometry;
        trackHistoryArray.forEach(function (value) {
          if (value.latitude !== 0 && value.longitude !== 0) {
            let latLng = {
              lat: value.latitude,
              lng: value.longitude
            };
            trackHistory.push(latLng);
          }
        });
        this.trackHistoryJson = trackHistory;
        this.trackHistoryJson.forEach((element, index) => {
          let self = this;
          setTimeout(() => {
            if (self.currentState == "history") {
              self.plotMarkerinMap(element);
            }
          }, index * 2000);
        });
      });
  }
  ngOnChanges() {
    if (this.gridLiveChange) {
      if (this.websocketService.isAlive('livetrack')) {
        if (this.traveVinData) {
          this.traveVinData = this.gridLiveChange;
        }
        if (this.traveVinData.vin != this.vin) {
          this.appSettings = JSON.parse(localStorage.appSettings);
          const duration = this.appSettings.liveTrackingDisconnect ? this.appSettings.liveTrackingDisconnect : this.appSettings.liveTrackingDelay;
          const credentials = {
            dashboardVin: this.vin,
            defaultInterval: duration,
            make: storageVariable.upDatedJsonData.liveDatas[this.vin].make,
            model: storageVariable.upDatedJsonData.liveDatas[this.vin].model,
            delay: duration,
            ImeiNo: storageVariable.upDatedJsonData.liveDatas[this.vin].imeiNo,
            entryPoint: app.entryPoint,
            Check: false,
            emailId: localStorage.userName,
            branchID: localStorage.corpId,
            companyID: localStorage.corpId,
            mode: 'liveTrackDisConnect'
          };
          // if (!this.restrictedCommandImei.includes(this.traveVinData.imeiNo))
          this.websocketService.reSendRequest(credentials);
          if (!this.map) {
            this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: this.traveVinData.latitude, lng: this.traveVinData.longitude }, false, false);
          }
          this.mapService.clearLayers(this.map, [1, 2]);
          this.paramVin = JSON.parse(localStorage.selectedVin).vin;
          this.appSettings = JSON.parse(localStorage.appSettings);
          this.ioData = JSON.parse(localStorage.staticIOData)[this.paramVin];
          this.traveVinData = storageVariable.upDatedJsonData.liveDatas[JSON.parse(localStorage.selectedVin).vin];
          this.position = {
            lat: this.traveVinData.latitude,
            lng: this.traveVinData.longitude
          };
          this.gridView.emit(this.traveVinData)
          this.createMap();
          this.trackHistory();
        }
      }
    }
    if (this.fromMultiTrack) {
      let vin = JSON.parse(localStorage.selectedVin).vin;

      vin = this.multiTrackObj['vin'];
      this.updateTracking(this.multiTrackObj);

    } else if (this.liveTrackChanging) {
      this.traveVinData = storageVariable.upDatedJsonData.liveDatas[JSON.parse(localStorage.selectedVin).vin];
      if (Object.keys(this.liveTrackChanging['liveDatas']).includes(this.traveVinData.vin)) {
        this.vin = this.traveVinData.vin
        const res = this.liveTrackChanging
        this.traveVinData = res["liveDatas"][this.traveVinData.vin];
        this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[this.traveVinData.status], this.commonService.vehicleModelmap[this.traveVinData.icon]);
        this.currentState = "live";

        this.traveVinData = res["liveDatas"][this.vin];

        this.successLiveVariableData(res);
        this.updateCellData();
      }
    }
  }
  updateTracking(data) {
    this.traveVinData = data;
    this.vin = this.traveVinData.vin
    this.liveTrackModel = this.getLiveTrackIcon(this.commonService.color[this.traveVinData.status], this.commonService.vehicleModelmap[this.traveVinData.icon]);
    this.currentState = "live";
    this.successLiveVariableData(data);
    this.updateCellData();

  }

  showLocation(data) {
    const url = serverUrl.web + "/login/company/latlngtoaddress/" + data.latitude + "/" + data.longitude + "/" + localStorage.corpId + "/" + localStorage.lang;
    this.ajaxService.ajaxGetObject(url)
      .subscribe(res => {
        if (JSON.stringify(res) == "{}") {
          data.location = data.latitude + ',' + data.longitude;
        } else {
          data.location = res;
        }

      });
  }

  ngOnInit() {
    this.appName = app.appName;
    this.pageSelector = localStorage.pageSelector
    if (this.fromMultiTrack) {
      this.setup(this.fromMultiTrack, this.multiTrackObj);
    } else {
      this.paramVin = JSON.parse(localStorage.selectedVin).vin;
      this.appSettings = JSON.parse(localStorage.appSettings);
      this.ioData = JSON.parse(localStorage.staticIOData)[this.paramVin];
      this.traveVinData = storageVariable.upDatedJsonData.liveDatas[JSON.parse(localStorage.selectedVin).vin];
      this.traveVinData['type'] = "liveTracking";
      this.vin = this.traveVinData.vin
      this.gridView.emit(this.traveVinData) // not used yet but don't delete
      this.createMap();
      // this.trackHistory();
      this.commonService.updateLanguageDir
        .subscribe(res => {
          this.directory = res == "" ? this.directory : res
        })
    }

  }
  setup(fromMultitrack = false, multiTrackObj) {
    let vin = JSON.parse(localStorage.selectedVin).vin;
    if (fromMultitrack) {
      vin = multiTrackObj.vin;
    }
    this.paramVin = vin;
    this.appSettings = JSON.parse(localStorage.appSettings);
    this.ioData = JSON.parse(localStorage.staticIOData)[this.paramVin];
    this.traveVinData = storageVariable.upDatedJsonData.liveDatas[vin];
    this.traveVinData['type'] = "liveTracking";
    this.vin = this.traveVinData.vin
    this.gridView.emit(this.traveVinData) // not used yet but don't delete
    this.createMap();
    //this.trackHistory();
    this.commonService.updateLanguageDir
      .subscribe(res => {
        this.directory = res == "" ? this.directory : res
      })
  }
}
